import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions } from '../../../widgets/models';
import { IWorkspace, WorkspaceService } from '../../../assessment/services/workspace.service';
import { CacheService, StaffItem } from '../../../../../services/cache.service';
import { MiroBoard, MiroNewBoard, MiroService } from '../../services/miro.service';
import { Staff } from '../../../common/model/Staff';
import { TileService } from '../../../widgets/services/tile.service';
import { ModalWrapperComponent } from '../../../widgets/components';
import { MultiSelectComponent } from '../../../assessment/multi-select/multi-select.component';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../../modules/fwcore';

@Component({
  selector: 'app-whiteboard-add',
  standalone: true,
  imports: [ModalWrapperComponent,ReactiveFormsModule,FormsModule,CommonModule, MultiSelectComponent],
  templateUrl: './whiteboard-add.component.html',
  styleUrls: ['./whiteboard-add.component.scss']
})
export class WhiteboardAddComponent implements OnInit {
  @Input() options: ModalOptions = new ModalOptions();
  whiteBoardForm!: FormGroup;
  workspaceId!: string;
  selectedWorkspace!: IWorkspace;

  currentUser!: StaffItem;
  userselectTitle: string = "Whiteboard Team Members";
  userselectPlaceholdertext: string = "Filter Team Members";

  workspaces: IWorkspace[] = [];
  allUsers: { [key: string]: any; } = [];
  selectedUsers: { [key: string]: any; } = [];
  newBoard!: MiroNewBoard;
  newBoardId: string = "";
  params: any[] = [];
  miroboards: MiroBoard[] = [];
  isNameDuplicated: boolean = false;
  allStaffList: Staff[] = [];
  teamMember: Staff[] = [];
  dummyAllStaffList: Staff[] = [];

  constructor(private userService:UserService,private modal: NgbActiveModal, private service: MiroService, private workspaceService: WorkspaceService, private cache: CacheService, private modalService: NgbModal, private tileService: TileService) { }

  ngOnInit(): void {

    if (this.params) {
      this.workspaceId = this.params[0];
    }

    this.whiteBoardForm = new FormGroup({
      whiteboardName: new FormControl("", Validators.required),
      whiteboardDescription: new FormControl(""),
      workspace: new FormControl("0")
    });

    // This clears the duplication event when the whiteboardName control value changes
    this.whiteBoardForm.controls['whiteboardName'].valueChanges.subscribe(() => {
      this.isNameDuplicated = false;
    });

    this.tileService.getCurrentUser().then((data: any) => {
      this.currentUser = data;
      this.retrieveWorkspaces();
      this.retrieveMiroBoards(data.emailAddress);
    });
    this.tileService.GetStaff().then((data) => {
      this.allStaffList = data;
      this.dummyAllStaffList = data;
      this.allStaffList.forEach((user) => {
        this.allUsers[user.emailAddress!] = user.userName
      })
    }).catch((revisedData) => {
      this.allStaffList = [];
    });
  }

  retrieveWorkspaces(): void {
    this.workspaceService.getWorkspacesForUser(false)
      .subscribe(
        data => {
          this.workspaces = data;
          this.setSelectedWorkspace();
        },
        error => {
          console.log(error);
        });
  }

  selectWorkspace(e: any) {
    this.workspaceId = this.whiteBoardForm.controls["workspace"].value;
    this.setSelectedWorkspace();
  }

  //private setSelectedWorkspace() {
  //  if (this.workspaceId) {
  //    this.selectedWorkspace = this.workspaces.filter(x => x.id == this.workspaceId)[0];
  //    if (this.selectedWorkspace.id) {
  //      this.whiteBoardForm.controls['workspace'].setValue(this.selectedWorkspace.id, { onlySelf: true });
  //      this.workspaceService.getTeamMembers(this.selectedWorkspace.id).subscribe(
  //        team => {
  //          team.forEach(user => {
  //            if (user.userEmail.length > 0) {
  //              this.selectedUsers[user.userEmail] = this.allUsers[user.userEmail]
  //            }
  //          });
  //        })
  //    }
  //  }
  //}
  private setSelectedWorkspace() {
    if (this.workspaceId) {
      this.selectedWorkspace = this.workspaces.filter(x => x.id == this.workspaceId)[0];
      if (this.selectedWorkspace.id) {
        this.whiteBoardForm.controls['workspace'].setValue(this.selectedWorkspace.id, { onlySelf: true });
        this.tileService.GetTeammemberDetails(this.workspaceId).then((data) => {
          this.teamMember = [];
          this.teamMember = data;
          this.teamMember.forEach((member) => {
            if (!member.workspaceOwner)
              this.selectedUsers[member.emailAddress!] = member.userName;
          });
        });
      }
    }
  }

  retrieveMiroBoards(useremail: string): void {
    try {
      this.service.getMiroBoardsForUser(useremail)
        .subscribe(
          data => {
            this.miroboards = data;
          },
          error => {
            console.error('Failed to retrieve Miro boards:', error);
            this.miroboards = [];
            // Optionally, show a user-friendly message here
          }
        );
    } catch (error) {
      this.miroboards = [];
    }
  }

  public onCancel() {
    this.modal.dismiss('Cancelled');
  }

  public async onSave() {
    if (this.validateForm()) {
      this.newBoard = {
        id: "",
        owner: this.currentUser.emailAddress,
        name: this.whiteboardName.value,
        description: this.whiteboardDescription.value,
        emailAddresses: Object.keys(this.selectedUsers)
      };

      this.newBoard = await this.service.createNewBoard(this.newBoard);

      // If the new board is linked to a workspace then add history 
      if (this.workspace.value != '0') {
        this.workspaceService.addHistory();
      }

      if (!this.workspaceId) {
        this.modal.close('Saved');
      }

      if (this.newBoard.id) {
        this.service.showMiroBoard(this.newBoard.id);
        if (this.workspaceId) {
          // Add Board as a link and remove from grid
          this.service.linkWorkspaceWhiteBoard(this.workspaceId, this.newBoard.id)
            .subscribe(
              data => {
                this.modal.close('Saved data successfully');
              },
              error => {
                console.log(error);
              });
        }
      }

      this.service.refresh();
    }

  }

  validateForm(): boolean {
    let isValid = this.whiteBoardForm.valid;
    this.isNameDuplicated = false;

    if (isValid) {
      // Ensure name has not been duplicated
      const miroboard = this.miroboards.find(x => x.name == this.whiteboardName.value)
      if (miroboard) {
        isValid = false;
        this.isNameDuplicated = true;
      }
    }

    return isValid;
  }

  // Event to capture selected users
  //getSelectedItems(data: { [key: string]: any; }) {
  //  this.selectedUsers = data;
  //}
  getSelectedItems(data: any) {
    this.teamMember = data;
  }


  get whiteboardName(): FormControl {
    return this.whiteBoardForm.get('whiteboardName') as FormControl;
  }

  get whiteboardDescription(): FormControl {
    return this.whiteBoardForm.get('whiteboardDescription') as FormControl;
  }
  get workspace(): FormControl {
    return this.whiteBoardForm.get('workspace') as FormControl;
  }

  get workspaceSelected(): boolean {
    return this.whiteBoardForm.get('workspace')?.value != '0';
  }
}
